export const defaultState = {
    filters: [],
    sorting: []
};

export default function user(state = defaultState, action) {
    switch (action.type) {
        case 'REQUEST_FILTERS_SET':
            return {
                ...state,
                filters: action.payload.filters,
                sorting: action.payload.sorting,
                page: action.payload.page,
                pageSize: action.payload.pageSize,
            };
        case 'REQUEST_FILTERS_RESET':
            return {
                ...state,
                filters: [],
                sorting: [],
                page: 0,
                pageSize: 25,
            };
        default:
            return state;
    }
}
